import { ReactNode } from 'react'
import { PanelState } from '@/console/state/panelState'
import { Callout } from './Callout'
import styles from './ResultState.module.css'

/**
 * 콘솔 전체의 상태 표시 규약. `ready` 일 때만 `children` 을 그대로 렌더하고,
 * 그 외 4상태는 `.cal` 톤으로 고정 문구를 렌더한다.
 *
 * `forbidden` 은 재시도 버튼을 두지 않는다 — @PreAuthorize 거절에 재시도 루프를 만들지 않기 위해서다.
 * 문구는 `state.message` 를 그대로 쓴다 — 권한부족 문구의 단일 출처는 `api/errors.ts` 의
 * `toPanelError`(`FORBIDDEN_MESSAGE`)다(Task 13 리뷰 지적 — 예전엔 이 파일에도 같은 문자열이
 * 따로 하드코딩돼 있어 한쪽만 바뀌면 조용히 어긋날 수 있었다).
 */
export type ResultStateProps = {
  state: PanelState<unknown>
  children: ReactNode
}

const MESSAGES = {
  idle: '조회 버튼을 누르면 지금 값을 가져옵니다.',
  loading: '가져오는 중…',
} as const

export const ResultState = ({ state, children }: ResultStateProps): JSX.Element | null => {
  if (state.status === 'ready') {
    return <>{children}</>
  }

  if (state.status === 'idle') {
    return (
      <div className={styles.wrap}>
        <Callout>{MESSAGES.idle}</Callout>
      </div>
    )
  }

  if (state.status === 'loading') {
    return (
      <div className={styles.wrap}>
        <Callout>{MESSAGES.loading}</Callout>
      </div>
    )
  }

  if (state.status === 'empty') {
    return (
      <div className={styles.wrap}>
        <Callout>{state.reason}</Callout>
      </div>
    )
  }

  if (state.kind === 'forbidden') {
    return (
      <div className={styles.wrap}>
        <Callout tone="crit">{state.message}</Callout>
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <Callout tone="crit">{state.message}</Callout>
    </div>
  )
}
